import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

/**
 * Translation safety net.
 *
 * Default ngx-translate behavior is to return the key string when a
 * translation is missing (e.g. typos, keys removed from locale files,
 * new keys not yet added to every locale). That leaks raw `foo.bar.baz`
 * strings into the UI, which we've agreed is never acceptable.
 *
 * This handler:
 *   1. Returns an empty string in production so the UI never shows a key.
 *   2. Logs a console warning in dev so the missing key is still visible
 *      to whoever's running the dev server — easy to find and fix.
 *
 * The `useDefaultLang` option on `TranslateModule.forRoot` is left at its
 * default (`true`), so this handler is only invoked when the key is
 * missing from the user's locale **and** from the default (`en`) locale.
 */
export class UtishaMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const key = params.key;
    if (typeof console !== 'undefined' && console.warn) {
      console.warn(`[i18n] missing translation key: "${key}"`);
    }
    return '';
  }
}
